module.exports = __webpack_public_path__ + "Roboto-Medium.cf4d60bc0b1d4b231408.woff";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/dist/fonts/roboto/Roboto-Medium.woff
// module id = 577
// module chunks = 2